module.exports = __webpack_public_path__ + "static/media/favicon-white.1e5846ad.png";